import React from 'react'
import BentoboxGrid from '../bentobox-grid'

const TypeOneInside = (props) => <BentoboxGrid {...props} inside={true} featured={false} />

export default TypeOneInside
